import { render, staticRenderFns } from "./StringboxFarmComparitonNew.vue?vue&type=template&id=29ed993e&scoped=true&"
import script from "./StringboxFarmComparitonNew.vue?vue&type=script&lang=js&"
export * from "./StringboxFarmComparitonNew.vue?vue&type=script&lang=js&"
import style0 from "./StringboxFarmComparitonNew.vue?vue&type=style&index=0&id=29ed993e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed993e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDatePicker,VMenu,VRow,VSpacer,VTextField})
